import uuidv1 from "uuid/v1";
import bus from "../../bus";
import Playable from "./playable";
import { playerEvents, playableItemEvents } from "../events";
import PlayableStream from "./items/stream";

/**
 * PlayableStreams
 *
 * Needs to implement the Playable API
 */
class PlayableStreams extends Playable {
  constructor(props) {
    super(props);
    // Create a "listen session" ID, used for ensuring the stream reloads in certain
    // situations
    this.listenSessionID = uuidv1();
    // Bind to instance
    this.onItemStatusChange = this.onItemStatusChange.bind(this);
    this.set(props);
    this._playables = {};
  }

  set(props) {
    this.props = props;
  }

  getPlayableStream(stream) {
    this._playables[stream.id] =
      this._playables[stream.id] || new PlayableStream(stream);
    return this._playables[stream.id];
  }

  currentItem() {
    const { state } = this.props;
    let { status, volume, muted } = state.player;
    volume = muted ? 0 : volume;
    const streamID = state.player.target.id;
    const stream = state.streams.available.find(s => s.id == streamID);
    if (stream) {
      const playable = this.getPlayableStream({ stream });
      // Bind listeners (once)
      playable.removeListener(
        playableItemEvents.STATUS_CHANGE,
        this.onItemStatusChange
      );
      playable.on(playableItemEvents.STATUS_CHANGE, this.onItemStatusChange);
      // Call set immediately but separately as we want to ignore player status
      // as part of the memoisation call
      playable.set({
        stream,
        status,
        volume,
        listenSessionID: this.listenSessionID
      });
      return playable;
    } else {
      console.warn("Could not resolve stream, may not have loaded.");
    }
  }

  prev() {
    return false;
  }

  next() {
    return false;
  }

  canPlayNext() {
    return false;
  }

  canPlayPrev() {
    return false;
  }

  play() {}

  pause() {}

  stop() {}

  catchUp() {
    this.listenSessionID = uuidv1();
    bus.emit(playerEvents.PLAY);
  }

  isLive() {
    return true;
  }

  onItemStatusChange({ status }) {
    switch (status) {
      case "playing":
        bus.emit(playerEvents.PLAY);
        break;
      case "paused":
        bus.emit(playerEvents.PAUSE);
        break;
      case "stopped":
        bus.emit(playerEvents.STOP);
        break;
      case "ended":
        // The stream should only end if it’s stalled for some reason
        // and we need to kick start it to wake up again
        if (console && console.warn) {
          console.warn("Stream ended, restarting");
        }
        bus.emit(playerEvents.PLAY);
        break;
      default:
        break;
    }
  }
}

export default PlayableStreams;
